import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export const project = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '项目模块',
            dataIndex: 'projectClassification',
            key: 'projectClassification',
            scopedSlots: {
                customRender: 'projectClassification'
            }
        },
        {
            title: '项目类型',
            dataIndex: 'projectType',
            key: 'projectType',
        },
        {
            title: '项目状态',
            dataIndex: 'projectStatus',
            key: 'projectStatus',
            scopedSlots: {
                customRender: 'projectStatus'
            }
        },
        {
            title: '样本数量',
            dataIndex: 'numberOfSamples',
            key: 'numberOfSamples',
            scopedSlots: {
                customRender: 'numberOfSamples'
            }
        },
        {
            title: '分析平台（数据量）',
            dataIndex: 'sizeOfSampleData',
            key: 'sizeOfSampleData',
            scopedSlots: {
                customRender: 'sizeOfSampleData'
            }
        },
        {
            title: '检测平台',
            dataIndex: 'sequencingPlatform',
            key: 'sequencingPlatform',
            scopedSlots: {
                customRender: 'sequencingPlatform'
            }
        },
        {
            title: '项目金额',
            dataIndex: 'projectAmount',
            key: 'projectAmount',
            scopedSlots: {
                customRender: 'projectAmount'
            }
        },
        {
            title: '最终结算金额',
            dataIndex: 'projectNewAmount',
            key: 'projectNewAmount',
            scopedSlots: {
                customRender: 'projectNewAmount'
            }
        },
        {
            title: '分析要求',
            dataIndex: 'analyzeRequirements',
            key: 'analyzeRequirements',
            scopedSlots: {
                customRender: 'analyzeRequirements'
            }
        },
        {
            title: '是否收样',
            dataIndex: 'collectingFlag',
            key: 'collectingFlag',
            scopedSlots: {
                customRender: 'collectingFlag'
            }
        },
        {
            title: '管理系统样品数量',
            dataIndex: 'sampleNum',
            key: 'sampleNum',
            scopedSlots: {
                customRender: 'sampleNum'
            }
        },
        {
            title: '是否质检',
            dataIndex: 'qualityFlag',
            key: 'qualityFlag',
            scopedSlots: {
                customRender: 'qualityFlag'
            }
        },
    ]
}
